import axios from 'axios';
import { toast } from 'react-toastify';
import { TOKEN ,DB_TOKEN} from '../../constants/storage-keys';
import {base_url} from '../../constants/api';
export interface IResponse<T> {
  code: number;
  message: string;
  data: T;
}
export const naxios = axios.create();
export const httpPost = <SR>(
  url: string,
  postdata: any,
  config: any = {}
): Promise<IResponse<SR>> => {
  return new Promise((resolve: any, reject: any) => {
    let apiUrl = url;
    // check url not start with http or https
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        apiUrl = base_url + url;
    }
    toast.promise(
      naxios.post(apiUrl, postdata, {
        headers: { 'x-api-key': localStorage.getItem(TOKEN),'x-db-key':localStorage.getItem(DB_TOKEN) },
      }),
      {
        pending: {
          render() {
            return config.message?.pending
              ? config.message.pending
              : 'Loading....';
          },
        },
        success: {
          render({ data }) {
            resolve(data?.data);
            if (config.message && config.message.success) {
              return config.message.success;
            }
            return data?.data.message;
          },
        },
        error: {
          render({ data }: any) {
            reject(data);
            if (config.message && config.message.error) {
              return config.message.error;
            }
            if (data.response) {
              return data.response.data.message;
            } else if (data.code === 'ERR_NETWORK') {
              return 'Server is not reachable';
            }
            return 'Something Went wrong';
          },
        },
      }
    );
  });
};
export const normalHttpPost = <SR>(
  url: string,
  postdata: any,
  config: any = {}
): Promise<IResponse<SR>> => {
  return new Promise((resolve, reject) => {
    naxios
      .post(url, postdata, {
        headers: { 'x-api-key': localStorage.getItem(TOKEN),'x-db-key':localStorage.getItem(DB_TOKEN) },
      })
      .then(({ data }) => {
        if (data.code === 200) {
          resolve(data);
        } else {
          toast.error(data.message);
          reject(data);
        }
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        }
        reject(err);
      });
  });
};
export const httpGet = <SR>(url: string): Promise<IResponse<SR>> => {
  return new Promise((resolve, reject) => {
    let apiUrl = url;
    // check url not start with http or https
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        apiUrl = base_url + url;
    }
    naxios
      .get(apiUrl, {
        headers: {
          'x-api-key': localStorage.getItem(TOKEN),
          'x-db-key':localStorage.getItem(DB_TOKEN)
        },
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        if (err.response && err.response.data.code===429) {
          toast.error(err.response.data.message);
        }
        // without this the promise never settles, so a caller awaiting a failed GET waits forever
        reject(err);
      });
  });
};
